module.exports = __webpack_public_path__ + "static/img/onsight_logo.c641b45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onsight_logo.png
// module id = 255
// module chunks = 1